const ACTIVITY_SUMMARY_SIGNIFICANT_DIGITS = 3;

export function formatActivitySummaryEnergyValue(value: number) {
  return Intl.NumberFormat('en', {
    notation: 'compact',
    maximumSignificantDigits: ACTIVITY_SUMMARY_SIGNIFICANT_DIGITS,
  }).format(value);
}
